import { StanBadge } from '@/components';
import { formatDateShort } from '@/lib/date';
import type { StanColumnDef } from '@/components/core-components/StanTable/StanTable.types';
import type { EmailRecipient } from '../types';
import { getEmailRecipientStatusText, getEmailRecipientStatusVariant } from '../logic/emailRecipientStatus.logic';

/**
 * Table column definitions for email recipients table
 * Shows recipients who received a specific email
 */
export const getEmailRecipientColumns = (): StanColumnDef<EmailRecipient>[] => [
    {
        id: 'name',
        header: 'Name',
        accessorKey: 'full_name',
        cell: info => {
            const value = info.getValue();
            return <span className='text-dark text-label-sm-regular'>{value as string}</span>;
        },
    },
    {
        id: 'email',
        header: 'Email',
        accessorKey: 'email',
        cell: info => {
            const value = info.getValue();
            return <span className='text-gray text-label-sm-regular'>{value as string}</span>;
        },
    },
    {
        id: 'status',
        header: 'Status',
        accessorKey: 'status',
        align: 'right',
        cell: info => {
            const row = info.row.original;
            const status = row.status;
            const timestamp = row.updated_at;
            const formattedDate = formatDateShort(timestamp, false, true);
            const statusText = getEmailRecipientStatusText(status);
            const statusVariant = getEmailRecipientStatusVariant(status);

            return (
                <div className='flex items-center justify-end gap-2'>
                    <span className='text-gray text-label-sm-regular'>{formattedDate}</span>
                    <StanBadge variant={statusVariant} size='sm'>
                        {statusText}
                    </StanBadge>
                </div>
            );
        },
    },
];
